import { IntegrationCatalogPage } from '@pwa/components/integrations/integration-catalog-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/org/$orgId/integrations/')({
	component: RouteComponent,
});

function RouteComponent() {
	const { orgId } = Route.useParams();
	return <IntegrationCatalogPage orgId={orgId} />;
}
